import { FieldStub } from "./_FieldStub";
import type { FieldPrimitiveProps } from "./types";

// STUB — CHG-1167 scaffold. Real impl lands γ CHG-1144 (asset library).
// Contract: specs/_product/field-primitive-registry.md §1 ('file_upload').
// Doctrine: feedback_field_primitive_components_canonical.md.

export function FileUploadField(props: FieldPrimitiveProps<File | string>) {
  return <FieldStub {...props} fieldType="file_upload" inputType="text" />;
}
